/* nl-read-progress — fills a bar with the share of the page the reader has scrolled.

   Root:   [data-nl-read-progress]       the bar's track (decorative: give it aria-hidden="true")
   Fill:   [data-nl-read-fill]           inside the root; its width is set to 0–100%
   State:  none besides the inline width; the section CSS owns every visual.
   Lifecycle: re-inits on shopify:section:load, tears down on :unload. */
(function () {
  var instances = {};

  function init(root) {
    if (!root || root.__nlRead) return;
    var fill = root.querySelector('[data-nl-read-fill]');
    if (!fill) return;
    var section = root.closest('[id^="shopify-section-"]');

    function update() {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      var share = h > 0 ? Math.min(1, Math.max(0, window.scrollY / h)) : 0;
      fill.style.width = (share * 100).toFixed(2) + '%';
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();

    root.__nlRead = true;
    instances[section ? section.id : 'x'] = function () {
      window.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
      delete root.__nlRead;
    };
  }

  function initAll(scope) {
    [].forEach.call((scope || document).querySelectorAll('[data-nl-read-progress]'), init);
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var k = e.target.id || 'x';
    if (instances[k]) { instances[k](); delete instances[k]; }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
})();
